import React from "react";
import bannerPurpleMetrics from "assets/images/banner-purple-metrics.png";

import {
  ContentBannerPurpleMetrics,
  ImageBannerPurpleMetrics,
  LinkPurpleMetrics,
} from "./styles";

const PESQUISA_MARCA_URL =
  "https://brand.indecx.com.br/survey?id=fb567272-c3db-4bf3-aba3-a2fc9d4e99ed&src=three_";

const BannerPurpleMetrics: React.FC = () => (
  <ContentBannerPurpleMetrics>
    <LinkPurpleMetrics
      href={PESQUISA_MARCA_URL}
      rel="noreferrer"
      target="_blank"
    >
      <ImageBannerPurpleMetrics src={bannerPurpleMetrics} />
    </LinkPurpleMetrics>
  </ContentBannerPurpleMetrics>
);

export default BannerPurpleMetrics;
